import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getList(params) {
  return request({
    url: URL.sys.regionWarehouseMappingGetList,
    method: 'get',
    params
  })
}

export function getMatchedRecords(params) {
  return request({
    url: URL.sys.regionWarehouseMappingGetMatchedRecords,
    method: 'get',
    params
  })
}

export function save(data) {
  return request({
    url: URL.sys.regionWarehouseMappingSave,
    method: 'post',
    data
  })
}

export function batchDelete(data) {
  return request({
    url: URL.sys.regionWarehouseMappingBatchDelete,
    method: 'post',
    data
  })
}
